module.exports = __webpack_public_path__ + "img/slide-2-en.fd809d64.png";